/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { NEGOTIABLE_QUOTE_FRAGMENT } from '@/quote-management/api/graphql/NegotiableQuoteFragment';

export const REMOVE_NEGOTIABLE_QUOTE_ITEMS_MUTATION = `
  mutation REMOVE_NEGOTIABLE_QUOTE_ITEMS_MUTATION(
    $quoteUid: ID!
    $quoteItemUids: [ID!]!
  ) {
    removeNegotiableQuoteItems(
      input: {
        quote_uid: $quoteUid
        quote_item_uids: $quoteItemUids
      }
    ) {
      quote {
        ...NegotiableQuoteFragment
      }
    }
  }
  ${NEGOTIABLE_QUOTE_FRAGMENT}
`;
